<template>
    <div>
        <ul class="mb-5">
            <template v-for="invite in paginate(invites)">
                <InviteRow @new-data="$emit('new-data')" :invite="invite" />
            </template>
        </ul>
        <div class="flex items-center justify-center gap-4">
            <button
                :disabled="currentPage === 0"
                class="disabled:text-salesium-grey-100"
                @click="prevPage"
            >
                Previous
            </button>
            <span>
                <button
                    v-for="(_, i) in Array.from(Array(pageCount))"
                    class="w-11 h-11 rounded-lg"
                    :class="{
                        'bg-salesium-blue text-white': i === currentPage,
                    }"
                    @click="setCurrentPage(i)"
                    :disabled="currentPage === i"
                >
                    {{ i + 1 }}
                </button>
            </span>
            <button
                :disabled="currentPage === pageCount - 1"
                class="disabled:text-salesium-grey-100"
                @click="nextPage"
            >
                Next
            </button>
        </div>
    </div>
</template>
<script>
import InviteRow from "./InviteRow.vue";
export default {
    data() {
        return {
            currentPage: 0,
        };
    },
    props: ["invites", "length"],
    components: { InviteRow },
    computed: {
        pageCount() {
            return Math.ceil(this.length / 8);
        },
    },
    methods: {
        paginate(array) {
            return array.slice(this.currentPage * 8, this.currentPage * 8 + 8);
        },
        nextPage() {
            if (this.currentPage < this.pageCount) {
                this.currentPage += 1;
            }
        },
        prevPage() {
            if (this.currentPage > 0) {
                this.currentPage -= 1;
            }
        },
        setCurrentPage(page) {
            this.currentPage = page;
        },
    },
};
</script>
